<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Cadastro de Frota - Carreta</app-titulo>
      <div class="header-buttons">
        <app-botao
          type="primario"
          class="button"
          text="Cadastrar Carreta"
          icon="assets/add.svg"
          (click)="navegarCarreta()"></app-botao>
        <app-botao
          type="upload"
          class="button"
          text="Enviar Planilha"
          icon="assets/add-excel.svg"
          (fileSelected)="uploadArquivo($event)"></app-botao>
        <app-botao
          type="secundario"
          [ariaPlaceholder]="'Baixar modelo'"
          width="40px"
          icon="assets/download.svg"
          (click)="this.downloadExcel()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Carretas</div>
        <div class="align-button">
          <form [formGroup]="form" (ngModelChange)="getCarreta()">
            <div class="table-filters">
              <app-input
                label="Placa:"
                placeholder="Pesquisar"
                name="TX_PLCA_CRRT"
                formControlName="TX_PLCA_CRRT"
                width="100%"></app-input>
            </div>
          </form>
        </div>
      </div>
      <app-loader [isLoading]="isLoading"></app-loader>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        label="Placa:"
        placeholder="Pesquisar "
        name="TX_PLCA_CRRT"
        formControlName="TX_PLCA_CRRT"
        width="100%"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>
<app-loader [isLoading]="isLoading"></app-loader>
